/** Matches the "(3) " / "(99+) " prefix this module puts on the tab title. */
const COUNT_PREFIX = /^\(\d+\+?\) /;

/** Tab title with the unread count in front, or the bare title when zero. */
export function badgedTitle(title: string, unreadCount: number): string {
  const base = title.replace(COUNT_PREFIX, "");
  if (unreadCount <= 0) return base;
  const label = unreadCount > 99 ? "99+" : String(unreadCount);
  return `(${label}) ${base}`;
}
